import { useEffect, useRef } from 'react';
import { relayoutPagesForVerticalZoom } from '@/components/canvas/workspace/model/pageArrangement';
import { useCanvasStore } from '@/components/canvas/store/canvas.store';

/** 纵向布局下随 zoom 调整页间距，避免缩小时页头与相邻页重叠 */
export function useVerticalLayoutZoomSpacing(
  workspacePageLayoutMode: string,
  zoom: number,
  pageLayoutKey: string,
) {
  const prevZoomRef = useRef(zoom);

  useEffect(() => {
    if (workspacePageLayoutMode !== 'vertical') {
      prevZoomRef.current = zoom;
      return;
    }

    const { pages } = useCanvasStore.getState();
    if (pages.length === 0) return;

    const next = relayoutPagesForVerticalZoom(pages, zoom);
    const yChanged = next.some((p, i) => p.workspaceLayout.y !== pages[i]?.workspaceLayout.y);
    if (yChanged || prevZoomRef.current !== zoom) {
      useCanvasStore.setState({ pages: next });
    }
    prevZoomRef.current = zoom;
  }, [workspacePageLayoutMode, zoom, pageLayoutKey]);
}
